import styled from "styled-components";

import { SecondaryText } from "@/shared/ui/Typography";

export const StyledSBMSum = styled(SecondaryText)`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.additionalTypographyColor} !important;
    text-decoration: underline;
    text-underline-offset: 3px;
`;

export const StyledSBMRaw = styled.div<{ $columns?: number }>`
    display: grid;
    grid-template-columns: repeat(${({ $columns }) => $columns ?? 2}, 1fr);
    width: 100%;
    gap: 8px;

    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }
`;

export const StyledNestedAccordionWrapper = styled.div`
    padding-top: 16px;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    background-color: ${(props) => props.theme.collapseHeaderBackground};
`;
